require('./payrollLoanRequestLowerBiggerImport.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @core
const { FormattedText } = require('core/i18n').i18n;
// @utilities
const { decimalsLength, getFormattedString } = require('utilities/currencyHelper');
// @components
const ContractLoanSliders = require('../../contractLoanSliders/contractLoanSliders');

class PayrollLoanRequestLowerBiggerImport extends React.Component {
    constructor(props) {
        super(props);

        this.state = { show: false };

        this.onHandleMinTermFunction = this.onHandleMinTermFunction.bind(this);
        this.handleSlide = this.handleSlide.bind(this);
    }

    componentDidMount() {
        const { validateAmountKOxDTI, immPayrollLoanRequest } = this.props;

        if (immPayrollLoanRequest.get('initialized')) {
            validateAmountKOxDTI();
        }
    }

    onHandleMinTermFunction() {
        const { getMinTerm } = this.props;
        getMinTerm();
    }

    buildIcon() {
        const { show } = this.state;
        let iconCss = 'icon payroll-loan-request-lower-bigger-import__icon icon-accordion-';
        iconCss += show ? 'cerrar' : 'abrir';

        return (
            <i className={iconCss} />
        );
    }

    buildOffer() {
        const { immPayrollLoanRequest } = this.props;
        const offer = immPayrollLoanRequest.get('offer');
        const decimalsLengthLoanImport = decimalsLength(offer);

        return getFormattedString({
            amount: offer,
            currency: immPayrollLoanRequest.get('currency'),
            decimalsLength: decimalsLengthLoanImport
        });
    }

    buildSliders() {
        const { show } = this.state;
        const { getInstallment, immPayrollLoanRequest, setLoanAmount, setLoanTerm } = this.props;

        return show ? (
            <div className="payroll-loan-request-lower-bigger-import__sliders">
                <ContractLoanSliders
                    termTitle="contractPayrollLoanBiggerImport-term"
                    getInstallment={getInstallment}
                    immContractLoan={immPayrollLoanRequest}
                    setLoanAmount={setLoanAmount}
                    setLoanTerm={setLoanTerm}
                    getMinTerm={this.onHandleMinTermFunction}
                    showTooltip
                    callFromKOxDTI
                />
            </div>
        ) : null;
    }

    handleSlide() {
        this.setState({ show: !this.state.show });
    }

    render() {
        const sliders = this.buildSliders();
        let icon = this.buildIcon();

        return (
            <section className="payroll-loan-request-lower-bigger-import">
                <div className="payroll-loan-request-lower-bigger-import__title" onClick={this.handleSlide}>
                    <div className="payroll-loan-request-lower-bigger-import__ajust">
                        <FormattedText value="contractPayrollLoanBiggerImport-ajust" />
                    </div>
                    {icon}
                </div>
                {sliders}
            </section>
        );
    }
}

PayrollLoanRequestLowerBiggerImport.propTypes = {
    immPayrollLoanRequest: PropTypes.object.isRequired,
    validateAmountKOxDTI: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired
};

module.exports = PayrollLoanRequestLowerBiggerImport;
